module.exports = __webpack_public_path__ + "img/btnCard-3-m.e04cfd87.jpg";